<template>
  <b-modal id="disburse-contract-modal" ref="modal" name="disburse" centered hide-footer hide-header>
    <center><h3><strong>{{ $t('TRANSACTION_TYPE') }}</strong></h3></center>
    <center>
      <select-input
        v-model="type"
        :items="types"
        :placeholder="$t('SELECT_ONE')"
        required
      />
    </center>
    <div class="controls">
      <primary-button @click="close" blue :text="$t('BACK')" />
      <primary-button @click="save" :disabled="!type" :text="$t('DISBURSE')" />
    </div>
  </b-modal>
</template>

<script>
import { watch, ref, computed } from '@vue/composition-api';
import PrimaryButton from '@/components/PrimaryButton';

import { CASH_LOG_TYPES } from '@/consts';

import SelectInput from '@/components/SelectInput';

export default {
  name: 'DisburseDialog',
  components: {
    PrimaryButton,
    SelectInput
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { root, emit }) {
    const type = ref(CASH_LOG_TYPES.CASH);
    const modal = ref(null);

    const types = Object.keys(CASH_LOG_TYPES).map((key) => ({
      value: key,
      text: root.$t(key)
    }));

    const close = () => {
      emit('input', false);
      type.value = null;
    };

    const save = async () => {
      emit('disburse', { type: type.value });
      close();
    };

    const popup = computed(() => props.value);
    watch(popup, (value) => {
      if (value) {
        modal.value.show();
      } else {
        modal.value.hide();
      }
    });

    return {
      modal,
      type,
      types,
      close,
      save,
    };
  },
};
</script>

<style lang="scss">
#disburse-contract-modal {
  .modal-body {
    padding: 30px 15px;
  }

  h3 {
    margin-bottom: 20px;
  }

  .select-input {
    min-width: 300px;

    .display {
      border-radius: 4px;
    }
  }

  .controls {
    margin-top: 20px;
    text-align: right;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
